import "./footer.css"
import {FaGithub} from 'react-icons/fa'
import {BsInstagram, BsLinkedin} from 'react-icons/bs'
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer >
     
      <a href="#" className='footer__logo'>João Victor</a>

      <ul className='permalinks'>
        <li><a href="#">{t("nav.home")}</a></li>
        <li><a href="#about">{t("nav.about")}</a></li>
        <li><a href="#experience">{t("nav.experience")}</a></li>
        <li><a href="#portfolio">{t("nav.portfolio")}</a></li>
        <li><a href="#contact">{t("nav.contact")}</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://github.com/JoaoVictorLiz" target="_blank"><FaGithub/></a>
        <a href="https://www.instagram.com/joaovc_liz/" target="_blank"><BsInstagram/></a>
        <a href="https://www.linkedin.com/in/joão-victor-liz-da-silveira-b347a71b5/" target="_blank"><BsLinkedin/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; JoaoVIctorLiz</small>
      </div>
  
    </footer>
  )
}

export default Footer